export const version = "networks/5.6.2";
//# sourceMappingURL=_version.js.map